import React from "react";
import List from '../../../components/CRM/List';
import {
  Datagrid,
  TextField,
  BooleanField,
  DateField
} from "admin-on-rest";
import {connect} from "react-redux";
import {listStyle} from "./style";
import ActionBar from "../../../components/CRM/ActionBar/";
import GameTipFilter from "./GameTipFilter";
import ActionMenu from "../../../components/CRM/ActionMenu";

class GameTipDataListBase extends React.Component {
  componentDidMount() {
    if (this.props.configuration && this.props.configuration.speltips) {
      const {history} = this.props;
      if (this.props.configuration.speltips.enabled !== true)
        history.replace(`/`);
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.speltips.enabled !== true)
        history.replace(`/`);
    }
  }

  render() {
    const props = {...this.props};
    return (
      <List
        title="resources.gametips.name"
        {...props}
        actions={<ActionBar deleteButton={false} />}
        sort={{field: "title", order: "ASC"}}
        filters={<GameTipFilter />}
      >
        <Datagrid
          options={{multiSelectable: true, selectable: true}}
          headerOptions={{
            enableSelectAll: true
          }}
          bodyOptions={{
            deselectOnClickaway: false,
            showRowHover: true
          }}
          rowOptions={{selectable: true}}
        >
          <TextField label="resources.gametips.fields.title" source="title" />
          <TextField label="resources.gametips.fields.author" source="author" />
          <DateField label="resources.gametips.fields.date" source="date" />
          <BooleanField
            elStyle={listStyle.booleanFieldStyle}
            label="resources.gametips.fields.published"
            source="published"
          />

          <ActionMenu deleteButton={false} showButton={true} />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = state => {
  return {
    configuration: state.configuration
  };
};

const GameTipDataList = connect(mapStateToProps)(GameTipDataListBase);

export default GameTipDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/GameTips/GameTipDataList.js